import isMobile from 'is-mobile'

const install = async function (Vue) {
  Vue.prototype.$device = { isMobile: isMobile() }
}

export default { install }
